// components/secure/OptedOutSendsPanel.js — owner decision O4 (audit 2026-10).
// Mailroom messages a sender chose to send, after the warning, to someone who had opted
// out. Managing broker only (GET /api/contact-compliance/opted-out-sends).
import React, { useEffect, useState } from 'react';
import { useApiClient } from '../../hooks/useApiClient';
import DataList from '../../components/shared/DataList';

const OptedOutSendsPanel = () => {
    const api = useApiClient();
    const [rows, setRows] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        api.get('/api/contact-compliance/opted-out-sends')
            .then(setRows)
            .catch((e) => setError(e.message || 'Could not load the list.'));
    }, [api]);

    return (
        <div className="bg-white rounded-lg shadow mt-6">
            <div className="px-4 py-3 border-b">
                <h2 className="font-semibold text-slate-800">Sent to opted-out contacts</h2>
                <p className="text-xs text-slate-500">
                    Mailroom messages sent anyway after the sender was warned the recipient had opted out.
                    The message itself is in the Mailroom under its number.
                </p>
            </div>
            {error && <p className="px-4 py-3 text-sm text-red-600">{error}</p>}
            {rows && rows.length === 0 && <p className="px-4 py-3 text-sm text-slate-500">None.</p>}
            {rows && rows.length > 0 && (
                <div className="p-3"><DataList rows={rows} rowKey="audit_id" csvName="opted-out-sends" defaultSort={{ key: 'occurred_at', dir: 'desc' }}
                    filters={[{ key: 'sender', label: 'Sender' }]}
                    columns={[
                        { key: 'occurred_at', label: 'When', type: 'date', render: (r) => <span className="whitespace-nowrap">{r.occurred_at ? new Date(r.occurred_at).toLocaleString() : ''}</span> },
                        { key: 'sender', label: 'Sender', value: (r) => r.username || `user ${r.user_id}` },
                        { key: 'summary', label: 'What' },
                    ]} /></div>
            )}
        </div>
    );
};

export default OptedOutSendsPanel;
